export default "__VITE_ASSET__Boy8SAO4__"